"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScaleUnit = void 0;
const MeasurementOverride_1 = require("../../api/objects/MeasurementOverride");
const ScaleUnitControls_1 = require("./components/ScaleUnitControls");
class ScaleUnit {
    constructor(webgl, alernativeParentEl = null) {
        this.scaleUnitFunctions = {
            scaleChange: () => this.change(),
            unitChange: () => this.change()
        };
        this.webgl = webgl;
        let parentEl;
        if (alernativeParentEl) {
            parentEl = alernativeParentEl;
        }
        else {
            parentEl = document.getElementById('scaleUnit');
        }
        if (!parentEl) {
            throw new Error("Parent element (scaleUnit) is undefined");
        }
        this.scaleUnitControls = new ScaleUnitControls_1.ScaleUnitControls(parentEl);
        this.addEvents();
        this.change();
    }
    dispose() {
        var _a;
        this.removeEvents();
        (_a = this.scaleUnitControls) === null || _a === void 0 ? void 0 : _a.dispose();
        delete this.scaleUnitControls;
        delete this.webgl;
    }
    addEvents() {
        var _a, _b;
        (_b = (_a = this.scaleUnitControls) === null || _a === void 0 ? void 0 : _a.unitSelect) === null || _b === void 0 ? void 0 : _b.setEvent('change', this.scaleUnitFunctions.unitChange);
    }
    removeEvents() {
        var _a, _b;
        (_b = (_a = this.scaleUnitControls) === null || _a === void 0 ? void 0 : _a.unitSelect) === null || _b === void 0 ? void 0 : _b.removeEvent('change', this.scaleUnitFunctions.unitChange);
    }
    getData() {
        var _a, _b;
        const measurementOverride = new MeasurementOverride_1.MeasurementOverride();
        measurementOverride.unit = (_b = (_a = this.scaleUnitControls) === null || _a === void 0 ? void 0 : _a.unitSelect) === null || _b === void 0 ? void 0 : _b.getValue();
        return measurementOverride;
    }
    setData(data) {
        var _a, _b;
        (_b = (_a = this.scaleUnitControls) === null || _a === void 0 ? void 0 : _a.unitSelect) === null || _b === void 0 ? void 0 : _b.setValue(data.unit);
        this.change();
    }
    change() {
        var _a;
        (_a = this.scaleUnitControls) === null || _a === void 0 ? void 0 : _a.refreshUI();
    }
}
exports.ScaleUnit = ScaleUnit;
